import { useParams } from 'react-router-dom';

import { PayrollEmployeePortal } from './EmployeePortal';

export const PayrollEmployeePortalRoute = () => {
  const params = useParams();
  const employeeId = params.employeeId ?? '';
  return <PayrollEmployeePortal employeeId={employeeId} />;
};

export default PayrollEmployeePortalRoute;
